var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dettaglio-custom-edit"},[_c('v-textarea',{on:{"onChange":function($event){return _vm.update()},"input":function($event){return _vm.debounceUpdate()}},model:{value:(_vm.dettaglio.note_attivita),callback:function ($$v) {_vm.$set(_vm.dettaglio, "note_attivita", $$v)},expression:"dettaglio.note_attivita"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }